export enum CART_ACTION_TYPES {
  ADD_ITEM = "cart/ADD_ITEM",
  REMOVE_ITEM = "cart/REMOVE_ITEM",
  UPDATE_ITEM = "cart/UPDATE_ITEM",
  CLEAR_CART = "cart/CLEAR_CART",
  SET_ORDER = "cart/SET_ORDER",
}
